<app-modal #transferModal [modalMessage]="question" (ok)="transfer()">
</app-modal>

<span *ngIf="showButton">
  <span *ngFor="let target of targets">
    <!-- comment / solution -->
    <button
      *ngIf="type === 'post'"
      class="btn btn-sm btn-clean"
      [title]="target.title"
      (click)="openConfirm(target.customer, transferModal)"
    >
      <i class="fas fa-share-square"></i>
      <span *ngIf="hasText">{{ buttonText }}</span>
    </button>

    <!-- case -->
    <button
      *ngIf="type === 'thread'"
      class="btn btn-sm btn-clean btn-transfer"
      [title]="target.title"
      [ngClass]="{ lightText: app.thread.changeHeadlineColor() }"
      (click)="openConfirm(target.customer, transferModal)"
    >
      <i class="fas fa-share-square"></i>&nbsp;
      {{ buttonText }}
    </button>
  </span>
</span>
